<template>
  <base-drawer
    title="Adicionar Cupom"
    :open="open"
    :close="drawerDetailClose"
    @onClose="resetStep()"
  >
    <base-steps
      ref="stepper"
      hideButtons
      class="d-flex flex-column"
      style="min-height: 100%; align-items: stretch"
    >
      <div :class="divulgationProp ? 'inactive' : ''">
        <base-card>
          <base-question text="O cupom será online ou offline?" class="mb_15" />
          <div class="d-flex">
            <div
              class="select-divulgation flex-column"
              v-bind:class="{
                selected: coupon.divulgation == DivulgationType.ONLINE,
              }"
              @click.prevent="setCouponDivulgation(DivulgationType.ONLINE)"
            >
              <p class="mb_10"><i class="fal fa-paper-plane"></i></p>
              <p>Divulgação Online</p>
            </div>
            <div
              class="select-divulgation flex-column"
              v-bind:class="{
                selected: coupon.divulgation == DivulgationType.OFFLINE,
              }"
              @click.prevent="setCouponDivulgation(DivulgationType.OFFLINE)"
            >
              <p class="mb_10"><i class="fal fa-ticket-alt"></i></p>
              <p>Divulgação Offline</p>
            </div>
          </div>
        </base-card>
      </div>

      <div>
        <base-card>
          <base-question text="Informe o código do cupom" class="mb_15" />
          <base-input
            placeholder="Ex. CODCUPOM20"
            v-model="coupon.code"
            class="mb_0"
            @blur="nextOnlyCode()"
            :valid="!this.couponError"
          />
          <base-message v-if="this.couponError" class="mt_10 red">
            {{ this.couponError }}
          </base-message>
        </base-card>
        <base-card>
          <base-question text="Descrição do cupom" class="mb_15" />
          <base-textarea :rows="4" v-model="coupon.description" class="mb_0" />
        </base-card>
        <base-card>
          <base-question text="Tipo do benefício" class="mb_20" />
          <base-radio
            family="giftType"
            class="mb_15"
            v-model="coupon.type"
            :option="freeDelivery"
            ><p class="radio-label">Entrega Grátis</p></base-radio
          >
          <base-radio
            family="giftType"
            class="mb_15"
            v-model="coupon.type"
            :option="moneyDiscount"
            ><p class="radio-label">Desconto em R$</p></base-radio
          >
          <base-radio
            family="giftType"
            v-bind:class="{ mb_20: coupon.type && coupon.type != freeDelivery }"
            v-model="coupon.type"
            :option="percentDiscount"
            ><p class="radio-label">Desconto em %</p></base-radio
          >

          <div v-if="coupon.type && coupon.type != freeDelivery">
            <base-question text="Informe o valor do benefício" class="mb_10" />
            <base-input
              v-if="coupon.type == moneyDiscount"
              class="mb_0"
              v-model="coupon.value"
              :money-mask="StringLanguage.currencyConfigs"
              design="two"
              key="moneyInput"
            />
            <base-input
              v-else
              design="two"
              class="mb_0"
              v-model="coupon.value"
              :mask="'##%'"
              key="percentInput"
            />
          </div>
        </base-card>
        <base-card>
          <base-question text="Modo de uso" class="mb_20" />
          <base-radio
            family="useMode"
            class="mb_15"
            v-model="coupon.use"
            :option="aTypes['N_USE']"
            ><p class="radio-label">Uso único por cadastro*</p></base-radio
          >
          <base-radio
            family="useMode"
            class="mb_20"
            v-model="coupon.use"
            :option="aTypes['FREE_TO_USE']"
            ><p class="radio-label">
              Usos ilimitados por cadastro*
            </p></base-radio
          >

          <div>
            <base-question
              text="Informe o valor mínimo do pedido"
              class="mb_10"
            />
            <base-input
              class="mb_0"
              design="two"
              v-model="coupon.min_order"
              :money-mask="StringLanguage.currencyConfigs"
            />
          </div>
        </base-card>
        <base-card>
          <base-question text="Este cupom possui expiração?" class="mb_20" />
          <base-radio
            family="hasExpiration"
            class="mb_15"
            v-model="hasExpiration"
            :option="'yes'"
            ><p class="radio-label">Sim</p></base-radio
          >
          <base-radio
            family="hasExpiration"
            v-bind:class="{ mb_20: hasExpiration == 'yes' }"
            v-model="hasExpiration"
            :option="'no'"
            ><p class="radio-label">Não</p></base-radio
          >

          <div v-if="hasExpiration == 'yes'">
            <base-question text="Defina a data de expiração" class="mb_10" />
            <base-input
              class="mb_0 w-100"
              type="tel"
              autocomplete="none"
              design="two"
              v-model="coupon.expiration"
              :mask="StringLanguage.dateMask"
              :masked="true"
              placeholder="00/00/0000"
            />
          </div>
        </base-card>

        <!-- Disponibilidade -->
        <!-- <base-availability
          name="do cupom"
          :availability="coupon.availability"
          @updateAvailability="updateAvailability"
          @hasDisponibility="setHasDisponibility"
          :isActive="hasDisponibility"
        ></base-availability> -->
        <!-- fim Disponibilidade -->

        <base-card v-if="coupon.divulgation == DivulgationType.OFFLINE">
          <base-checkbox v-model="coupon.show" :checked="coupon.show"
            ><p class="radio-label">Mostrar na loja online</p></base-checkbox
          >
        </base-card>
      </div>

      <div
        :class="coupon.divulgation == DivulgationType.ONLINE ? '' : 'inactive'"
      >
        <coupons-publish-form
          ref="publishForm"
          :coupon="coupon"
          @onFinish="$emit('onAddFinish')"
        />
      </div>
    </base-steps>

    <template slot="footer">
      <base-button
        @click="drawerDetailClose = true && next()"
        class="w-100"
        :text="'Criar'"
      />
    </template>
  </base-drawer>
</template>

<script>
import Vue from 'vue';

import Gift, { TYPE as aTypes, DivulgationType } from 'easyjs/lib/Schema/Gift';
import BaseButton from '@/components/Button';
import BaseCard from '@/components/Card';
import BaseDrawer from '@/components/Drawer';
import BaseQuestion from '@/components/Question';
import BaseSteps from '@/components/Steps';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseRadio from '@/components/Radio';
import BaseCheckbox from '@/components/Checkbox';
import BaseAvailability from '@/containers/AvailabilityCoupon';
import BaseTextarea from '@/components/Textarea';
import BaseMessage from '@/components/Message';

import CouponsMessage from '@/containers/Coupons/Forms/CouponsMessage';
import CouponsPublishForm from '@/containers/Coupons/Forms/CouponsPublishForm';

import GiftAPI from '@/api/coupon';
import Utils from '@/utils';

export default {
  props: {
    divulgationProp: { type: String, default: '' },
    open: { type: Boolean, default: false },
    close: { type: Boolean, default: false },
  },
  data() {
    return {
      drawerDetailClose: false,
      aTypes,
      DivulgationType,
      coupon: Gift.fromObject({ show: true }),
      hasExpiration: '',
      hasDisponibility: 'always',
      drawers: {
        messageDrawer: { open: false, close: false },
      },
      couponError: '',
      oldCouponCode: '',
    };
  },
  methods: {
    setHasDisponibility(newDisponibility) {
      this.hasDisponibility = newDisponibility;
    },
    resetStep() {
      this.coupon = Gift.fromObject({ show: true });
      this.hasExpiration = '';
      this.couponError = '';
      this.hasDisponibility = '';
      this.$refs.stepper.current = 1;
      this.coupon.divulgation = this.divulgationProp;
    },
    next() {
      if (this.$refs.stepper) {
        const currentStep = this.$refs.stepper.current;
        let partDate = ['01', '01', '2999'];

        if (this.hasExpiration === 'yes') {
          partDate = this.coupon.expiration.split('/');
        }

        const dateExpiration = new Date(
          `${partDate[2]}/${partDate[1]}/${partDate[0]}`
        );
        const today = new Date();

        if (this.couponError !== '') {
          alert('Código de cupom já utilizado!');
          return false;
        }

        if (currentStep == 1 && !this.coupon.divulgation) {
          alert('Selecione a forma de divulgação do cupom!');
          return false;
        }

        if (currentStep == 2 || (currentStep == 1 && this.divulgationProp)) {
          if (!this.isCouponValid()) {
            alert('Preencha todas as informações');
            return false;
          }

          if (dateExpiration < today || dateExpiration == 'Invalid Date') {
            alert('Data de expiração inválida');
            return false;
          }

          if (this.coupon.divulgation == DivulgationType.OFFLINE) {
            return this.saveCoupon();
          }
        }

        if (currentStep == 3) {
          if (!this.$refs.publishForm.isCampaignValid()) {
            return false;
          }

          return this.saveCoupon().then((response) => {
            if (response.getErrors([]).length > 0) {
              return;
            }

            const responseData = response.getData({});
            this.coupon.id = responseData.id;

            return this.$refs.publishForm
              .addCampaign()
              .then((responseCampaign) => {
                if (responseCampaign.getErrors([]).length > 0) {
                  return alert(StringLanguage.saveError);
                }

                this.$emit('onAddFinish');
              });
          });
        }

        this.$refs.stepper.next();
      }
    },

    getCoupons() {
      return GiftAPI.list(false).then((response) => {
        return response.getData([]);
      });
    },

    async nextOnlyCode() {
      this.couponError = '';
      const coupons = await this.getCoupons();
      coupons.map((value, _index) => {
        if (value.code === this.coupon.code) {
          this.couponError = 'Código de cupom já utilizado.';
        }
      });
    },

    setCouponDivulgation(divulgationType) {
      this.coupon.divulgation = divulgationType;
    },
    updateAvailability(newAvailability) {
      Vue.set(this.coupon, 'availability', newAvailability);
    },
    saveCoupon() {
      return GiftAPI.create({
        ...this.coupon,
        expiration: this.coupon.expiration
          ? new Date(Utils.switchDayMonth(this.coupon.expiration)).getTime() /
            1000
          : null,
        type: +this.coupon.type + +this.coupon.use,
      }).then((response) => {
        const reponseErrors = response.getErrors([]).length > 0;

        if (reponseErrors) {
          alert(StringLanguage.saveError);
        }

        if (!reponseErrors && alert('Cupom criado com sucesso!')) {
          this.openDrawer('messageDrawer');
        }

        return response;
      });
    },
    isCouponValid() {
      const { code, description, type, use, expiration, value, availability } =
        this.coupon;

      if (!code || !description || !type || !use || !value) {
        return false;
      }

      if (!this.hasExpiration || !this.hasDisponibility) {
        return false;
      }

      if (
        (this.hasExpiration == 'yes' && !expiration) ||
        (this.hasDisponibility == 'availability' &&
          availability.daysOfTheWeek == 0)
      ) {
        return false;
      }

      if (
        !!availability &&
        availability.periods.length > 0 &&
        !availability.periods[0].beginTimeIsValid &&
        !availability.periods[0].endTimeIsValid
      ) {
        return false;
      }

      return true;
    },
    openDrawer(drawerName) {
      this.drawers[drawerName].open = !this.drawers[drawerName].open;
    },
    closeDrawer(drawerName) {
      this.drawers[drawerName].close = !this.drawers[drawerName].close;
    },
  },
  computed: {
    freeDelivery() {
      return aTypes.PERCENT + aTypes.DELIVERY;
    },
    moneyDiscount() {
      return aTypes.PRICE + aTypes.CART;
    },
    percentDiscount() {
      return aTypes.PERCENT + aTypes.CART;
    },
  },
  watch: {
    'coupon.code': function (newData, oldData) {
      if (newData) {
        if (newData.length > 10) {
          this.coupon.code = oldData;
        } else {
          this.coupon.code = newData.replace(/[^a-z0-9]/gi, '').toUpperCase();
        }
      }
    },
    'coupon.description': function (newData, oldData) {
      if (newData && newData.length > 140) {
        this.coupon.description = oldData;
      }
    },
    'coupon.type': function (newData) {
      if (newData == this.freeDelivery) {
        this.coupon.value = 100;
      }
    },
    divulgationProp: {
      immediate: true,
      handler() {
        this.coupon.divulgation = this.divulgationProp;
      },
    },
  },
  components: {
    BaseButton,
    BaseSteps,
    BaseCard,
    BaseInput,
    BaseRadio,
    BaseCheckbox,
    BaseQuestion,
    BaseBox,
    BaseDrawer,
    BaseAvailability,
    BaseTextarea,
    BaseMessage,
    CouponsMessage,
    CouponsPublishForm,
  },
};
</script>

<style scoped>
.select-divulgation {
  background: var(--box-up);
  min-height: 95px;
  width: 100%;
  color: #aaaaab;
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.select-divulgation:first-child {
  margin-right: 20px;
}
.select-divulgation i {
  color: #8c8c8c;
  font-size: 20px;
}

.select-divulgation.selected {
  color: var(--default);
}

.select-divulgation.selected i {
  color: var(--default);
}

@media screen and (max-width: 991px) {
  .select-divulgation:first-child {
    margin-right: 0;
  }
}
</style>
